import request from '../../../../../setup/axios/request'
import requestFile from '../../../../../setup/axios/request-file'

const lang = localStorage.getItem('i18nConfig')
const lang_r = lang ? JSON.parse(lang).selectedLang : 'VI'

export const calculatorFeeMoto = (data: any) => {
  data.languageCode = lang_r.toUpperCase()
  return request({
    url: '/api/v1/Pricing/caculator-fee-moto',
    method: 'post',
    data: data,
  })
}

export const step2AddMotoObjectInsured = (data: any) => {
  return request({
    url: '/api/v1/SellingMoto/step2-object-insured-moto-details-add',
    method: 'post',
    data: data,
  })
}

export const step2GetObjectInsuredMotoList = (data: any) => {
  let obj = {
    Page: data.pageNumber,
    PageSize: data.pageSize,
    Filters: data.filter,
  }
  return request({
    url: '/api/v1/SellingMoto/step2-object-insured-moto-list',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const step2GetObjectInsuredMotoByID = (data: any) => {
  return request({
    url:
      '/api/v1/SellingMoto/step2-object-insured-moto-detail-byid?sellingContractId=' +
      data.sellingContractId +
      '&id=' +
      data.id,
    method: 'get',
  })
}

export const step2UploadMotoInsured = (data: any) => {
  const formData = new FormData()
  formData.append('file', data.file)
  formData.append('SellingContractId', data.sellingContractId)
  formData.append('PackageCode', data.packagesCode)
  return requestFile({
    url: '/api/v1/SellingMoto/step-object-insured-moto-insert-excel',
    method: 'post',
    data: formData,
  })
}
